// @flow

export const SETTINGS_PERSONAL_INIT = 'SETTINGS_PERSONAL_INIT'
export const SETTINGS_PERSONAL_INIT_SUCCESS = 'SETTINGS_PERSONAL_INIT_SUCCESS'
export const SETTINGS_PERSONAL_INIT_ERROR = 'SETTINGS_PERSONAL_INIT_ERROR'
export const SETTINGS_PERSONAL_UPDATE = 'SETTINGS_PERSONAL_UPDATE'
export const SETTINGS_PERSONAL_SAVE = 'SETTINGS_PERSONAL_SAVE'
export const SETTINGS_PERSONAL_SAVED = 'SETTINGS_PERSONAL_SAVED'
export const SETTINGS_PERSONAL_CANCEL = 'SETTINGS_PERSONAL_CANCEL'
